module.exports = __webpack_public_path__ + "img/pq_element-06.bda93c6d.png";